import * as React from "react";
const SvgFiRrCamping = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-camping_svg__a)">
      <path
        fill="#062147"
        d="M5.005 24H19a5 5 0 0 0 4.522-7.132L16.535 2.9a5 5 0 0 0-9.057-.026l-7 14-.008.026A5 5 0 0 0 5.005 24m3.4-2 2.717-5.438A.96.96 0 0 1 12 16a.97.97 0 0 1 .893.588L15.6 22zm-6.127-4.252 7-14.012a3 3 0 0 1 5.454.027l6.988 13.973A3 3 0 0 1 19 22h-1.164L14.7 15.72a2.97 2.97 0 0 0-5.377-.027L6.168 22H5.005a3 3 0 0 1-2.727-4.252"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-camping_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCamping;
